import { cn } from "@/lib/utils";

export const ServiceCard = ({ service, index, testid, className }) => {
  const Icon = service.icon;
  return (
    <div
      data-testid={testid}
      className={cn(
        "group relative flex h-full flex-col border border-white/10 bg-ink-surface p-7 transition-colors duration-300 hover:border-gold/40",
        className,
      )}
    >
      <div className="mb-6 flex items-center justify-between">
        <span className="flex h-12 w-12 items-center justify-center rounded-sm border border-white/10 bg-ink text-gold transition-colors duration-300 group-hover:border-gold/50">
          <Icon className="h-5 w-5" />
        </span>
        {index != null && (
          <span className="font-heading text-sm font-bold text-white/15">
            {String(index).padStart(2, "0")}
          </span>
        )}
      </div>
      <h3 className="font-heading text-xl font-bold tracking-tight text-white">
        {service.title}
      </h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-steel">{service.short}</p>
    </div>
  );
};
